import { gql } from '__generated__';

export default gql(`
  mutation DeactivateDiscount($id: ID!) {
    deactivateDiscount(id: $id) {
      id
      active
    }
  }
`);
